// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"71a6b55b","231":"5cebb263","293":"56dfdd78","301":"8cdeea59","379":"17811d62","642":"67e24482","810":"4515d329","938":"f8f79648"}[chunkId] + ".chunk.js";
};